import {isEqual} from 'lodash';
import {useMemo} from 'react';

import {usePropsSelector} from '../../../../state/hooks';
import {makePanelsBySectionSelector} from '../../../../state/views/panelBankConfig/selectors';
import {getKey} from '../../../../util/panels';
import {useWorkspaceRefsContext} from '../../../Workspace/WorkspaceRefsContext';
import {useWorkspaceDrawerContext} from '../../WorkspaceDrawerContextProvider';

export const useNumPanelsByKey = () => {
  const {panelBankConfigRef} = useWorkspaceRefsContext();
  const {targetSectionRef} = useWorkspaceDrawerContext();
  const isGlobalQuickAdd = !targetSectionRef;

  const panelsBySection = usePropsSelector(
    makePanelsBySectionSelector,
    panelBankConfigRef
  );

  return useMemo(() => {
    const global = new Map<string, number>();
    const inScope = isGlobalQuickAdd ? global : new Map<string, number>();
    // need to exclude last section AKA hidden panels
    panelsBySection.slice(0, -1).forEach(({sectionRef, panels}) => {
      const isTargetSection = isEqual(sectionRef, targetSectionRef);
      panels.forEach(panel => {
        const key = getKey(panel);
        if (!key) {
          return;
        }
        const curGlobalCount = global.get(key) ?? 0;
        global.set(key, curGlobalCount + 1);
        if (isTargetSection) {
          const curSectionCount = inScope.get(key) ?? 0;
          inScope.set(key, curSectionCount + 1);
        }
      });
    });
    return {global, inScope};
  }, [isGlobalQuickAdd, panelsBySection, targetSectionRef]);
};
